import { createFileRoute } from "@tanstack/react-router";
import { LegalSettingsEditor } from "@/features/admin-settings/LegalSettingsEditor";
function Page() { const { session } = Route.useRouteContext(); return <LegalSettingsEditor key={session.user.id} actorId={session.user.id} />; }
export const Route = createFileRoute("/_authenticated/_protected/_admin/admin/legal")({ component: Page });
